import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDown, ChevronUp, ChevronsUpDown } from "lucide-react";
export const SortableTableHeader = ({ label, field, sort, }) => {
    const isSorted = sort.field === field;
    const Icon = isSorted ? (sort.dir === "asc" ? ChevronUp : ChevronDown) : ChevronsUpDown;
    return (_jsxs("span", { className: "cursor-pointer select-none", onClick: () => sort.onSort(field), children: [label, _jsx(Icon, { size: 14, style: { marginLeft: "0.3em", opacity: isSorted ? 1 : 0.3 }, className: "inline" })] }));
};
